import { z } from "zod";
import { AdvisorInfoSchema } from "../Entity/Types";
import { TaskV3_1 } from "../Tasks/Types";
import { Custodian, TaskId } from "../Types";
export const OnboardingStatus = z.enum([
    "InRecruiting",
    "KickoffComplete",
    "TransitionInProgress",
    "LaunchComplete",
    "Delayed",
]);
export const TransitionStatus = z.enum(["OnTrack", "Delayed", "OffTrack"]);
export const Sentiment = z.enum(["Good", "Mixed", "Low", "AtRisk"]);
export const RegistrationStatus = z.enum([
    "NotRegistered",
    "Registered",
    "DualRegistered",
]);
export const TransitionPhase = z.enum([
    "NotStarted",
    "KickOffComplete",
    "PendingRegistration",
    "NclNoticeSent",
    "InTransition",
    "ReadyForHandoff",
]);
export const TransitionType = z.enum(["LPOA", "MasterMerge", "ACAT"]);
export const FamOnboardingStatus = z.enum([
    "IntroToFam",
    "FamTransitionAnalysis",
    "FamAdoptionUnderway",
    "FamAdoptionComplete",
]);
export const DocumentToSign = z.object({
    name: z.string(),
    additionalInfo: z.string().optional(),
});
export const Documents = z.object({
    documentsToSign: z.array(DocumentToSign),
    accountNumbers: z.string(),
    signatureMethod: z.string(),
    standingInstructions: z.string(),
});
const VirtualSubtaskBase = z.object({
    title: z.string(),
    taskStatus: z.string(),
    description: z.string().optional(),
    dueDate: z.string().optional(),
    taskPriority: z.string().optional(),
    taskType: z.string().optional(),
    assigneeId: z.string().optional(),
    serviceTeamId: z.string().optional(),
});
export const VirtualSubtask = VirtualSubtaskBase.extend({
    children: z.array(z.lazy(() => VirtualSubtask)).optional(),
});
export const Transition = z.object({
    transitionId: z.string(),
    taskId: TaskId,
    onboardingStatus: OnboardingStatus,
    transitionStatus: TransitionStatus,
    transitionPhase: TransitionPhase.nullable(),
    team: z.string().nullable(),
    sentiment: Sentiment.nullable(),
    transitionedAum: z.number().nonnegative().nullable(),
    transitionedAumPercent: z.number().min(0).max(100).nullable(),
});
export const TransitionDTO = Transition.extend({
    task: TaskV3_1,
});
export const TransitionDetails = Transition.extend({
    highlightsAndLowlights: z.string().nullable(),
    recentUpdates: z.string().nullable(),
    operationalNotes: z.string().nullable(),
    registrationStatus: RegistrationStatus.nullable(),
    advWDeadline: z.string().nullable(),
    transitionType: TransitionType.nullable(),
    custodian: Custodian.nullable(),
    custodianRepCode: z.string().nullable(),
    priorFirm: z.string().nullable(),
    additionalEmployees: z.number().int().nonnegative().nullable(),
    households: z.number().int().nonnegative().nullable(),
    docsSentPercent: z.number().int().min(0).max(100).nullable(),
    docsSignedPercent: z.number().int().min(0).max(100).nullable(),
    portalsCreatedPercent: z.number().int().min(0).max(100).nullable(),
    billing: z.string().nullable(),
    bdBulkRequest: z.string().nullable(),
    bdBulkRequestSubmissionDate: z.string().nullable(),
    famOnboardingStatus: FamOnboardingStatus.nullable(),
    expectedAum: z.number().nonnegative().nullable(),
    cxTeamLead: z.string().nullable(),
    onboardingManager: z.string().nullable(),
    marketingOwner: z.string().nullable(),
    marketingManager: z.string().nullable(),
    executiveSponsor: z.string().nullable(),
    documents: Documents.optional(),
});
export const TransitionDetailsDTO = TransitionDetails.extend({
    task: TaskV3_1,
    advisors: AdvisorInfoSchema.array(),
});
//# sourceMappingURL=Types.js.map